import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import Documents from './Documents';
export default function LoadDocumentsSection(element, handle, url, documents) {
    const root = createRoot(element);
    root.render(_jsx(Documents, { documents: documents }));
}
